/*
 * 项目通用api
 */
/*
 * 全部引用示例 *
import { get, post, head, options, put, patch } from "@utils/request";
export const requestGet = (params) => get("url", params);
export const requestPost = (params) => post("url", params);
export const requestHead = (params) => head("url", params);
export const requestOptions = (params) => options("url", params);
export const requestPut = (params) => put("url", params);
export const requestPatch = (params) => patch("url", params);
*/

import { post, get, customRequest } from "../utils/request";
import axios from "axios";

//获取cas信息
export const apiGetCasConfig = (params) =>
  post("/user/login/get_urls/", params);

// 用户登录
export const userLogin = (params) => post("/user/login/", params);

// 统一认证登录
export const userTokenLogin = (params) => get("/user/login/", params);

// 获取登录信息
export const apiGetUrlLink = (params) =>
  get("/user/login/get_url_link/", params);

// cas管理员登录
export const apiAdminLogin = (params) =>
  post("/user/login/admin_login/", params);

// 用户登出
export const apiUserLoginOut = (params) =>
  post("/user/login/login_out/", params);

// 获取publickey
export const apiGetPublicKey = (params) =>
  post("/user/commonInterface/get_public_key/", params);

// 获取用户信息
export const apiGetUserInfo = (params) =>
  post("/user/api/v1.organization/getUserInfo/", params);

// 更改密码
export const apiChangePwd = (params) =>
  post("/user/api/v1.user/change_pwd/", params);

// 校验密码强度
export const apiCheckUser = (params) =>
  customRequest("/user/api/v1.user/check_user/", params, "post");

//获取用户列表
export const apiGetUserList = (params) =>
  post("/workflow/commonInterface/get_user_list/", params);

//获取组织机构人员
export const apiGetTreeNodeOrLeaf = (params) =>
  customRequest("/workflow/commonInterface/get_tree_node_or_leaf/", params);

//获取组织机构部门
export const apiGetMultipleTreeNode = (params) =>
  customRequest("/user/api/v1.organization/get_multiple_tree_node/", params);

/* 消息中心api */
// 获取服务分类
export const apiGetServerApp = (params) =>
  get("/message/api/v1.message/get_server_app/", params);

// 获取消息列表
export const apiGetMessage = (params) =>
  get("/message/api/v1.message/", params);

// 标记为已读
export const apiReadMessage = (params) =>
  post("/message/api/v1.message/read_message/", params);

// 消息数量
export const apiMessageCount = (params) =>
  get("/message/api/v1.message/message_count/", params);

// 获取消息数量
export const apiUserMessageCount = (params) =>
  get("/message/api/v1.message/user_message_count/", params);

// 全局搜索
export const apiGlobalSearch = (params) =>
  post("/portal/portal/portalIndex/search/", params);

// 获取热门事项数据
export const getTopAffairs = (params) =>
  post("/affairs/portal/portalIndex/topAffairs/", params);

// 获取热门问题数据
export const getTopQuestions = (params) =>
  post("/intelligentQuery/query/intellQuery/topQuestions/", params);

// 获取搜索事项服务数据
export const getSpecifiedAffairs = (params) =>
  post("/affairs/portal/portalIndex/specifiedAffairs/", params);

// 获取搜索数据服务数据
export const getFindSearchForm = (params) =>
  post("/biEngine/service/mySetting/findSearchForm/", params);

// 获取登录用户网站配置
export const apiGetConfig = (params) =>
  post("/portal/backend/organizationConfig/getConfig/", params);

// 获取访客网站配置
export const apiGetCommonConfig = (params) =>
  post("/portal/backend/organizationConfig/getCommonConfig/", params);

// 获取用户登录状态
export const apiCheckUserIsLogin = (params) =>
  customRequest("/user/api/v1.user/check_user_is_login/", params, "post");

// 获取主题
export const apiGetTheme = (params) =>
  post("/portal/backend/organizationConfig/getTheme/", params);

// 更换主题
export const apiSaveTheme = (params) =>
  post("/portal/backend/organizationConfig/saveTheme/", params);
/**
 * 获取成员
 * "Offset": 0,
 * "Limit": 0,
 * "keyword": "string",
 */
export const apiUserList = (params) => {
  const url = params.scope
    ? "/user/api/v3.user/getUserList/"
    : "/user/api/v1.organization/getUserList/";

  return post(url, params);
};

/**
 * 获取组织机构
 * "id": 0,
 */
export const apiTreeNode = (params) =>
  customRequest("/user/api/v2.organization/getTreeNode/", params, "post");

/*
 * 获取组织机构
 * "id": 0,
 */

export const apiTreeNodeEdit = (params) =>
  customRequest(
    "/user/api/v2.organization/getTreeNodeForEdit/",
    params,
    "post"
  );

/**
 * 获取组织机构
 * "keyword": "string",
 */
export const apiTreeNodeSearch = (params) =>
  customRequest(
    "/user/api/v2.organization/getTreeNodeForSearch/",
    params,
    "post"
  );

/**
 * 获取角色组树
 * "id": "string",
 */
export const apiRoleGroup = (params) =>
  customRequest("/user/api/v2.role/getRoleGroup/", params, "post");

/**
 * 搜索角色组树
 * "keyword": "string",
 */
export const apiRoleGroupForSearch = (params) =>
  customRequest("/user/api/v2.role/getRoleGroupForSearch/", params, "post");

/**
 * 选择平台
 * @param {String}  platform_id
 */
export const apiChoicePlatform = (params) =>
  post("/user/api/v1.platform/choice_platform/", params);

/* 消息-根据任务获取表单
 * 'task_id':  "string"
 */
export const apiGetReceiveFormYids = (params) =>
  post(
    "/reportFormsCenter/api/v1/reportCenterTaskSetting/getReceiveFormYids/",
    params
  );

/**
 * 获取当前用户所属部门
 * @param {String} username
 * @returns
 */
export const apiGetDepartment = (params) =>
  post("/user/api/v1.organization/getDepartment/", params);

/**
 * 上传头像图片
 * @param {String} avatar
 * @returns
 */
export const apiUploadAvatar = (params) =>
  post("/portal/api/v1.userCenter/uploadAvatar/", params);
/**
 * 获取头像图片
 * @param {String} avatar
 * @returns
 */
export const apiGetMyInfo = (params) =>
  post("/portal/api/v1.userCenter/getMyInfo/", params);
/**
 * 上传签名图片
 * @param {String} avatar
 * @returns
 */
export const apiUploadSignature = (params) =>
  post("/workflow/api/v1.approval/upload_signature/", params);
/**
 * 获取签名图片
 * @param {String} avatar
 * @returns
 */
export const apiGetSignature = (params) =>
  post("/workflow/api/v1.approval/get_signature/ ", params);

/**
 * 获取登录配置
 * @param {*} params
 */
export const apiGetLoginConfig = (params) =>
  post("/portal/backend/organizationConfig/getLoginConfig/", params);

/**
 *  帮助中心 列表
 *
 *  @param { string } keyword 关键字搜索
 *  @param { date } upload_time__gte 上传时间(左值)
 *  @param { date } upload_time__lte 上传时间(右值)
 *  @return { Promise }
 *
 *  @return { jsonList } rows 数据列表
 *  @return { number } rows.id ID
 *  @return { date } rows.update_at 更新时间
 *  @return { string } rows.name 文件名
 *  @return { string } rows.file 附件
 *  @return { string } rows.creator_name 创建人姓名
 *  @return { string } rows.creator_username 创建人用户名
 *  @return { date } rows.upload_time 上传时间
 *  @return { number } total 总数
 **/
export const apiHelpCenterList = (params) =>
  post("/portal/indexConfig/helpCenter/list/", params);

/**
 * @description 获取小程序端审批详情
 * @param {*} data 小程序传递获取审批详情参数
 */
export const getMobileformApprovalDetail = (data) => {
  const { Authorization, approvalType, ...reset } = data;
  const formTypes = {
    dsp: "pending",
    wfq: "mySubmit",
    ysp: "processed",
    cswd: "copyToMe",
  };
  if (reset.app == "workflow") {
    return axios({
      url: `/workflow/service/${formTypes[approvalType]}/formApprovalDetail/`,
      method: "POST",
      headers: { AuthorizationMobile: Authorization, "from-mobile": 1 },
      data: reset,
    });
  } else {
    const formTypes = {
      dsp: "bookPending",
      wfq: "bookSubmit",
      ysp: "bookProcessed",
      cswd: "bookCopyToMe",
    };
    return axios({
      url: `/resourceReservation/reservationService/${formTypes[approvalType]}/formApprovalDetail/`,
      method: "POST",
      headers: { AuthorizationMobile: Authorization, "from-mobile": 1 },
      data: reset,
    });
  }
};
